import React, { useEffect, useState } from "react";
import InputForm from "../../../components/Input/InputForm";
import CloseIcon from "../../../components/Icon/Close";
import { Fab, withStyles } from "@material-ui/core";
import Dialog from "../../../components/Dialog/Dialog";
import { Button } from "../../../components/ui/Buttons";

const ModalEncaminhamentos = ({
  classes,
  open,
  handleClose,
  handleSave,
  encaminhamentoEdit,
}) => {
  const [inputs, setInputs] = useState({});

  useEffect(() => {
    if (encaminhamentoEdit) {
      setInputs({
        nome: encaminhamentoEdit.nome,
        descricao: encaminhamentoEdit.descricao,
      });
    }
  }, [encaminhamentoEdit]);

  const handleChange = (e, field) => {
    setInputs({ ...inputs, [field]: e?.target?.value });
  };

  return (
    <Dialog open={open} close={handleClose} classes={{ paper: classes.dialog }}>
      <div className={classes.headerModal}>
        <div className={classes.title}>Novo Encaminhamento</div>
        <Fab id="cfg-men-btn-fec" size={"small"} color={"secondary"} onClick={handleClose}>
          <CloseIcon></CloseIcon>
        </Fab>
      </div>
      <div className={classes.contentInput}>
        <label className={classes.label}>Nome do encaminhamento*</label>
        <InputForm
          id="cfg-men-inp-nom"
          classes={{ input: classes.input }}
          onChange={(e) => handleChange(e, "nome")}
          value={inputs?.nome || ""}
        />
      </div>
      <div className={classes.contentInput}>
        <label className={classes.label}>Informe uma descrição*</label>
        <InputForm
          id="cfg-men-inp-des"
          classes={{ input: classes.input }}
          onChange={(e) => handleChange(e, "descricao")}
          value={inputs?.descricao || ""}
        />
      </div>
      <div className={classes.button}>
        <Button
          id="cfg-men-btn-sal"
          width={"170px"}
          onClick={() => handleSave({ ...encaminhamentoEdit, ...inputs })}
        >
          Salvar
        </Button>
      </div>
    </Dialog>
  );
};

const styles = {
  headerModal: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignContent: "center",
    alignItems: "center",
  },
  content: {
    height: "100%",
  },
  title: {
    fontWeight: 700,
    fontSize: "18px",
  },
  dialog: {
    display: "flex",
    minWidth: "744px",
    maxWidth: "744px",
    minHeight: "260px",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: "25px",
  },
  contentInput: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    fontWeight: "400",
    color: "#9C9C9C",
  },
  button: {
    display: "flex",
    width: "100%",
    justifyContent: "flex-end",
  },
  input: {
    background: "#f2f2f2",
    border: "none",
    borderRadius: " 8px",
  },
};

export default withStyles(styles)(ModalEncaminhamentos);
